var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseGreen = function SvgCloseGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.386 16 5.724-5.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.886 0L16.5 14.114l-5.724-5.723a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.615 16l-5.724 5.724a1.332 1.332 0 1 0 1.885 1.885l5.724-5.724 5.724 5.724a1.33 1.33 0 0 0 1.886 0 1.332 1.332 0 0 0 0-1.885L18.386 16Z",
    fill: "#008545"
  })));
};
export default SvgCloseGreen;